import React, { Component } from 'react';
import $ from 'jquery/dist/jquery.min.js';
import DashboardHeaderIcons from '../dashboardHeaderIcons';
import Filter_Icon from '../css/dark/img/filter-outline.svg';
import Search_Icon from '../css/dark/img/theme-images/search.svg';
import FilterNew from '../css/dark/img/theme-images/filter-new.svg';
import WhFilterPopup from './../Wholesaler/Filter';
import DisFilterPopup from './../Distributor/Filter';
import AdFilterPopup from './../Admin/Filter';
import ConfirmReload from './../../components/ConfirmReload';
import DateRangePicker from 'react-bootstrap-daterangepicker';
import 'bootstrap-daterangepicker/daterangepicker.css';
import moment, { relativeTimeRounding } from 'moment';
import { BrowserRouter as Router, Route, NavLink, Link } from 'react-router-dom';
import PubSub from 'pubsub-js';

class AnalyticsHeader_API extends Component {
    constructor(props) {
        super(props);
        var startdate = new Date();
        startdate.setDate(startdate.getDate() - 7);
        var enddate = new Date();
        if (localStorage.getItem('User_Start_Date_API') != "" && localStorage.getItem('User_Start_Date_API') != null && localStorage.getItem('User_Start_Date_API') != undefined) {
            startdate = localStorage.getItem('User_Start_Date_API');
        }
        if (localStorage.getItem('User_End_Date_API') != "" && localStorage.getItem('User_End_Date_API') != null && localStorage.getItem('User_End_Date_API') != undefined) {
            enddate = localStorage.getItem('User_End_Date_API');
        }
        this.handleChangeDate = this.handleChangeDate.bind(this);
        this.handlechangea = this.handlechangea.bind(this);
        this.handleCalendar = this.handleCalendar.bind(this);
        //this.handleFilterClick = this.handleFilterClick.bind(this);
        // this.handleDropDownChange = this.handleDropDownChange.bind(this);
        //this.HandleRXSRadioButton = this.HandleRXSRadioButton.bind(this);
        //this.handleDropDownChange = this.handleDropDownChange.bind(this);
        //this.CreateNewFilter = this.CreateNewFilter.bind(this);
        //this.ConfirmReloadPopUp = this.ConfirmReloadPopUp.bind(this);
        var _roletype = '', _rolename = '';
        try {
            var userdata = JSON.parse(localStorage.getItem('user'));
            _roletype = userdata.userrole;
            _rolename = userdata.paramsname;
        }
        catch (error) { }
        this.state = {
            dashboardName: JSON.parse(localStorage.getItem('user')).dList[0].dashboardName,
            dashboardList: [],
            ConfirmReloadPopUp: false,
            radioButtonSelection: false,
            radioButtonValue: 'totalpaid',
            searchTextSelection: false,
            searchTextType: '',
            searchTextValue: '',
            AdFilterPopup: false,
            WhFilterPopup: false,
            CreateNewFilter: false,
            DisFilterPopup: false,
            ConfirmationMessageTitle: '',
            userdata: JSON.parse(localStorage.getItem('user')),
            UserFilter: [],
            UserFilterList: [],
            SearchDispay: [],
            startDate: new moment(startdate).format("MM/DD/YYYY"),
            endDate: new moment(enddate).format("MM/DD/YYYY"),
            roletype: _roletype,
            rolename: _rolename
        }
    }
    HandleSearchTextConfirmation(e) {
        this.setState({ searchTextSelection: false });
        //this.ConfirmReloadPopUp();
        //this.Create_Advance_FIlter_Json_Without_Refresh(e[0], e[1]);
        let CT = this.state.ClaimType;
        CT.forEach(c => {
            if (c.value == 'totalpaid') {
                c.isChecked = true;
            }
            else {
                c.isChecked = false;
            }
        });
        this.setState({ ClaimType: CT });
        this.Create_Advance_FIlter_Json_Without_Refresh(e[0], e[1], 'Search');
        var LocalHDType = localStorage.getItem('Updated_HD_Type_API');
        localStorage.setItem('Prev_HD_Type_API', LocalHDType);
        localStorage.setItem('Updated_HD_Type_API', 'totalpaid');
        let newDate = new Date();
        localStorage.setItem('Filter_Last_Update_Time_API', newDate);
        this.handlechangea();

    }
    Create_Advance_FIlter_Json_Without_Refresh(nodetype, nodevalue, Confirm_Type) {
        var Created_Advance_Filter = JSON.parse(localStorage.getItem('Advance_Filter_API'));
        var arr = [];
        if (Created_Advance_Filter != null && Created_Advance_Filter != '' && Created_Advance_Filter != undefined && Created_Advance_Filter != "null" && Created_Advance_Filter != "{}") {
            var IsMatched = false;
            Object.keys(Created_Advance_Filter).forEach(key => arr.push({ Name: key, Value: Created_Advance_Filter[key] }))
            for (var ij = 0; ij < arr.length; ij++) {
                if (arr[ij].Name == nodetype) {
                    IsMatched = true;
                    let checkavail = 0;
                    Created_Advance_Filter[nodetype].map((e1, i1) => {
                        if (e1.toLowerCase() == nodevalue.toLowerCase()) {
                            checkavail = checkavail + 1;
                        }
                    });
                    if (checkavail == 0) {
                        Created_Advance_Filter[nodetype].push(nodevalue);
                        localStorage.setItem('Advance_Filter_API', JSON.stringify(Created_Advance_Filter));
                        let newDate = new Date();
                        localStorage.setItem('Filter_Last_Update_Time_API', newDate);
                        localStorage.setItem('Updated_AdFilter_Status_API', JSON.stringify(Created_Advance_Filter));
                        // this.handlechangea();

                    }
                    break;
                }
                else {
                    continue;
                }
            }
            if (IsMatched == false) {
                try {
                    var JsonData = "\"" + nodetype + "\"" + ': [' + "\"" + nodevalue + "\"" + ']';
                    let TempJson = JSON.stringify(Created_Advance_Filter).replace('{', '').replace('}', '');
                    TempJson = '{' + TempJson + ',' + JsonData + '}';
                    localStorage.setItem('Advance_Filter_API', TempJson);
                    let newDate = new Date();

                    localStorage.setItem('Filter_Last_Update_Time_API', newDate);
                    localStorage.setItem('Updated_AdFilter_Status_API', TempJson);
                    //this.handlechangea();

                }
                catch (error) {
                }
            }

        }
        else {
            var JsonData = '';
            try {
                JsonData = "\"" + nodetype + "\"" + ': [' + "\"" + nodevalue + "\"" + ']';
                JsonData = '{' + "\"" + "dataset" + "\"" + ': {' + JsonData + '}}';
                localStorage.setItem('Advance_Filter_API', JSON.stringify(JSON.parse(JsonData)["dataset"]));
                let newDate = new Date();
                localStorage.setItem('Filter_Last_Update_Time_API', newDate);
                localStorage.setItem('Updated_AdFilter_Status_API', JSON.stringify(Created_Advance_Filter));
            }
            catch (error) {

            }
        }
    }
    handleChangeDate(e) {
        this.props.handleChangeDateNew(e);
    }
    handlechangea(e) {
        this.props.handeChangefilter(e);
    }
    GetUserFilterSet(FilterName, FilterJson, DashboardId) {
        try {
            const requestOptions = {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ FilterName, FilterJson, DashboardId })
            };
            return fetch(`/api/Filter/GetUserAdFilter`, requestOptions)
                .then(this.handleResponse)
                .then(apidata => {
                    try {
                        this.setState({ UserFilterList: apidata[0]["filterset"] });
                    }
                    catch (error) {
                    }
                });
        }
        catch (error) {
        }
    }
    componentWillUnmount() {
        PubSub.unsubscribe(this.token)
    }
    subscriber(msg, data) {
        try {
            document.getElementById('totalpaid1').checked = true;
            let CT = this.state.ClaimType;
            CT.forEach(c => {
                if (c.value == 'totalpaid') {
                    c.isChecked = true;
                }
                else {
                    c.isChecked = false;
                }
            });
            this.setState({ ClaimType: CT });
        }
        catch (error) {
        }
    }
    componentDidMount(e) {

        $('.readonly-attr').attr('readonly', 'readonly');

        this.token = PubSub.subscribe('PBM', this.subscriber.bind(this))
        // outside click close filter
        $(document).click(function (event) {
            event.stopPropagation();
            $('.filterDropdown').slideUp();
            $('.filterNewDesign').removeClass('active');
            $('.filterDropdown2').slideUp();
            $('.filterNewDesign2').removeClass('active');
            $('#myInputautocomplete-list').slideUp();
        });
        $('.filter-over').click(function (event) {
            event.stopPropagation();
            $('.filterDropdown').slideToggle();
            $('.filterNewDesign').toggleClass('active');
            $('#myInputautocomplete-list').slideUp();
            $('.filterDropdown2').slideUp();
            $('.filterNewDesign2').removeClass('active');
        });
        $('.filter-over2').click(function (event) {
            event.stopPropagation();
            $('.filterDropdown2').slideToggle();
            $('.filterNewDesign2').toggleClass('active');
            $('#myInputautocomplete-list').slideUp();
            $('.filterDropdown').slideUp();
            $('.filterNewDesign').removeClass('active');
        });

        var user = JSON.parse(localStorage.getItem('user'));
        //if (user) {
        //    this.setState({
        //        ...this.state,
        //        dashboardList: user.dList
        //    })
        //    this.props.dashboardListRendered($("#dashboard_select option:selected").text());
        //}

        if (this.state.userdata.userrole == "Admin") {
            this.GetFilterData('/api/admin/Admin_filter', "admin");
        }
        this.GetUserFilterSet('', '', this.state.userdata["dList"][0].dashboardId);
        $("#myInput").focus(function () {
            $('.searchSection').addClass('active');
        });
        $("#myInput").focusout(function () {
            $('.searchSection').removeClass('active');
        });
        if (this.state.userdata.userrole == "Admin") {
            try {
                var saved_type = localStorage.getItem('Updated_HD_Type')
                let CT = this.state.ClaimType;
                if (saved_type != undefined && saved_type != null && saved_type != '' && saved_type != 'null') {

                    CT.forEach(c => {
                        if (c.value === saved_type) {
                            c.isChecked = true;
                        }
                        else {
                            c.isChecked = false;
                        }
                    });
                }
                else {
                    CT.forEach(c => {
                        if (c.value === 'compensable') {
                            c.isChecked = true;
                        }
                        else {
                            c.isChecked = false;
                        }
                    });
                }
                this.setState({ ClaimType: CT });
                var checkforfilter = localStorage.getItem('Advance_Filter_API');
                if (checkforfilter != undefined && checkforfilter != null && checkforfilter != '' && checkforfilter != 'null') {
                    let checked_type = this.state.ClaimType.filter((x) => {
                        return x.isChecked === true;
                    });
                    if (checked_type.length > 0) {
                        window.localStorage.setItem('Advance_Filter_API', checkforfilter);
                        window.localStorage.setItem('Updated_HD_Type_API', checked_type[0].value);
                    } else {
                        window.localStorage.setItem('Advance_Filter_API', checkforfilter);
                        window.localStorage.setItem('Updated_HD_Type_API', 'totalpaid');
                    }
                }
                else {
                    if (checkforfilter === 'null') {
                        window.localStorage.setItem('Advance_Filter_API', null);
                        window.localStorage.setItem('Updated_HD_Type_API', 'totalpaid');
                    }
                    else {
                        //window.localStorage.setItem('Advance_Filter_API', '{"PBM":["HD"]}');
                        //window.localStorage.setItem('Updated_HD_Type_API', 'compensable');
                    }
                }
            }
            catch (error) { }
        }
        else {
            try {
                let CT = this.state.ClaimType;
                CT.forEach(c => {
                    if (c.value === 'totalpaid') {
                        c.isChecked = true;
                    }
                    else {
                        c.isChecked = false;
                    }
                });
                this.setState({ ClaimType: CT });
                window.localStorage.setItem('Updated_HD_Type_API', 'totalpaid');
            }
            catch (error) { }
        }

    }
    GetFilterData(API_URL, uname) {

        const requestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ uname })
        };
        return fetch(API_URL, requestOptions)
            .then(this.handleResponse)
            .then(apidata => {
                try {
                    this.setState({ UserFilter: apidata });
                    localStorage.setItem('Prev_Filter_Status_API', apidata[0]["select_sort_name"][0].id + "_" + apidata[0]["select_sort_value"] + "_" + apidata[0]["select_processor"][0].id);
                    localStorage.setItem('Updated_Filter_Status_API', apidata[0]["select_sort_name"][0].id + "_" + apidata[0]["select_sort_value"] + "_" + apidata[0]["select_processor"][0].id);
                    localStorage.setItem('Prev_AdFilter_Status_API', apidata[0]["select_sort_name"][0].id + "_" + apidata[0]["select_sort_value"] + "_" + apidata[0]["select_processor"][0].id);
                    localStorage.setItem('Updated_AdFilter_Status_API', apidata[0]["select_sort_name"][0].id + "_" + apidata[0]["select_sort_value"] + "_" + apidata[0]["select_processor"][0].id);

                }
                catch (error) {
                }
            });
    }
    HandleSearchFocus = e => {
        if ($('#myInput').val().length == 0) {
            this.setState({ SearchDispay: null });
        }
    }
    HandleSearchKeyUp = e => {
        if ($('#myInput').val().length >= 2) {
            this.GetSearchDataList($('#myInput').val(), this.state.roletype, this.state.rolename, this.state.userdata.wholesaler_Id.toString());
        }
        else {
            this.setState({ SearchDispay: null });
        }
    }

    GetSearchDataList(text, roletype, rolename, whname) {
        $('#myInputautocomplete-list').css('display', 'block');
        const requestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ text, roletype, rolename, whname })
        };
        return fetch(`/api/Filter/SearchOnTypeText_AnalyticAPI`, requestOptions)
            .then(this.handleResponse)
            .then(apidata => {
                try {
                    this.setState({ SearchDispay: apidata });
                }
                catch (error) {
                    this.setState({ SearchDispay: null });
                }
            });
    }

    HandleSearchItemClick = e => {
        $('#myInput').val('');
        $('#myInputautocomplete-list').css('display', 'none');
        this.setState({ SearchDispay: [] });
        var nodevalue = $(e.target).attr('nodevalue');
        var nodetype = $(e.target).attr('nodetype');
        this.Create_Advance_FIlter_Json(nodetype, nodevalue);
    }
    Create_Advance_FIlter_Json(nodetype, nodevalue) {
        var Created_Advance_Filter = JSON.parse(localStorage.getItem('Advance_Filter_API'));
        var arr = [];
        if (Created_Advance_Filter != null && Created_Advance_Filter != '' && Created_Advance_Filter != undefined && Created_Advance_Filter != "null" && Created_Advance_Filter != "{}") {
            var IsMatched = false;
            Object.keys(Created_Advance_Filter).forEach(key => arr.push({ Name: key, Value: Created_Advance_Filter[key] }))
            for (var ij = 0; ij < arr.length; ij++) {
                if (arr[ij].Name == nodetype) {
                    IsMatched = true;
                    let checkavail = 0;
                    Created_Advance_Filter[nodetype].map((e1, i1) => {
                        if (e1.toLowerCase() == nodevalue.toLowerCase()) {
                            checkavail = checkavail + 1;
                        }
                    });
                    if (checkavail == 0) {
                        Created_Advance_Filter[nodetype].push(nodevalue);
                        localStorage.setItem('Advance_Filter_API', JSON.stringify(Created_Advance_Filter));
                        let newDate = new Date();
                        localStorage.setItem('Filter_Last_Update_Time_API', newDate);
                        localStorage.setItem('Updated_AdFilter_Status_API', JSON.stringify(Created_Advance_Filter));
                        this.handlechangea();

                    }
                    break;
                }
                else {
                    continue;
                }
            }
            if (IsMatched == false) {
                try {
                    var JsonData = "\"" + nodetype + "\"" + ': [' + "\"" + nodevalue + "\"" + ']';
                    let TempJson = JSON.stringify(Created_Advance_Filter).replace('{', '').replace('}', '');
                    TempJson = '{' + TempJson + ',' + JsonData + '}';
                    localStorage.setItem('Advance_Filter_API', TempJson);
                    let newDate = new Date();

                    localStorage.setItem('Filter_Last_Update_Time_API', newDate);
                    localStorage.setItem('Updated_AdFilter_Status_API', TempJson);
                    this.handlechangea();

                }
                catch (error) {
                }
            }

        }
        else {

            var JsonData = '';
            try {
                JsonData = "\"" + nodetype + "\"" + ': [' + "\"" + nodevalue + "\"" + ']';
                JsonData = '{' + "\"" + "dataset" + "\"" + ': {' + JsonData + '}}';
                localStorage.setItem('Advance_Filter_API', JSON.stringify(JSON.parse(JsonData)["dataset"]));
                let newDate = new Date();
                localStorage.setItem('Filter_Last_Update_Time_API', newDate);
                localStorage.setItem('Updated_AdFilter_Status_API', JSON.stringify(Created_Advance_Filter));
                this.handlechangea();

            }
            catch (error) {

            }
        }
    }
    handleResponse(response) {
        return response.text().then(text => {
            try {
                const data = text && JSON.parse(text);
                return data;
            }
            catch (error) {
                return [];
            }
        });
    }
    handleCalendar(e, picker) {
        let changedStartDate = new moment(picker.startDate).format("MM/DD/YYYY");
        let changedEndDate = new moment(picker.endDate).format("MM/DD/YYYY");
        localStorage.setItem('User_Start_Date_API', changedStartDate);
        localStorage.setItem('User_End_Date_API', changedEndDate);
        this.handleChangeDate(changedStartDate + '-' + changedEndDate);
        try {
            $('.first-one .form-control').val(changedStartDate);
            $('.second-one .form-control').val(changedEndDate);
        }
        catch (error) {
        }
    }
    filterDropdown() {
        $('.filterDropdown').slideToggle();
        $('.filterNewDesign').toggleClass('active');
    }
    handleAdFilterClick = e => {
        e.stopPropagation();
        try {
            let TagDynamic = '';
            let fid = parseInt($(e.target).attr('filterid'));
            let SelectedFiltorJson = this.state.UserFilterList.filter((did) => did.dashboardId == fid);
            //this.GetUserFilterMatchingTag_FilterClick(this.state.roletype, this.state.rolename, this.state.startDate, this.state.endDate, JSON.stringify(JSON.parse(SelectedFiltorJson[0]["filterJson"])["dataset"]), fid);
            $('.filterDropdown').slideToggle();
            try {
                localStorage.setItem('Updated_AdFilter_Status_API', JSON.stringify(JSON.parse(SelectedFiltorJson[0]["filterJson"])["dataset"]));
                localStorage.setItem('Advance_Filter_API', JSON.stringify(JSON.parse(SelectedFiltorJson[0]["filterJson"])["dataset"]));
                let newDate = new Date();
                localStorage.setItem('Filter_Last_Update_Time_API', newDate);
            } catch (error) {
            }
            if ($("input[name=rxsprocrss]:checked").val() != "totalpaid") {
                let CT = this.state.ClaimType;
                this.setState({ ClaimType: CT });
                var LocalHDType = localStorage.getItem('Updated_HD_Type_API');
                localStorage.setItem('Prev_HD_Type_API', LocalHDType);
                localStorage.setItem('Updated_HD_Type_API', 'HD');
                let newDate = new Date();
                localStorage.setItem('Filter_Last_Update_Time_API', newDate);
            }

            this.handlechangea();
        }
        catch (error) { }
    }
    ConfirmReloadPopUp(type = null) {
        /* if (this.state.ConfirmReloadPopUp == true) {*/
        try {
            let CT = this.state.ClaimType;
            CT.forEach(c => {
                if (c.value == localStorage.getItem('Updated_HD_Type_API')) {
                    c.isChecked = true;
                }
                else {
                    c.isChecked = false;
                }
            });
            this.setState({ ClaimType: CT });
        }
        catch (error) { }
        /* }*/
        this.HandleRadioButtonConfirmation(type);
        //this.setState({
        //    ConfirmReloadPopUp: !this.state.ConfirmReloadPopUp
        //});

    }
    ConfirmReloadPopUp_SearchText(type, value) {
        try {
            let CT = this.state.ClaimType;
            CT.forEach(c => {
                if (c.value == localStorage.getItem('Updated_HD_Type_API')) {
                    c.isChecked = true;
                }
                else {
                    c.isChecked = false;
                }
            });
            this.setState({ ClaimType: CT });
        }
        catch (error) { }
        /* }*/
        let fieldValue = [];
        fieldValue.push(type);
        fieldValue.push(value);
        this.HandleSearchTextConfirmation(fieldValue);
    }
    render() {
        //        this.updatedateonfilterclick();
        return (
            <div id="dashboard_header" className="big_dash_header">
                <div className="dashboard-icons">

                    <DashboardHeaderIcons />

                </div>
                <div id="dashboard_header_inner">
                    <div id="dashboard-back-button"></div>
                    <div id="dashboard_header_select" className={this.state.userdata.isBrokerTypeUser ? 'broker-active' : ''}>
                        <DateRangePicker
                            initialSettings={{
                                startDate: this.state.startDate,
                                endDate: this.state.endDate,
                                maxDate: moment().toDate(),
                                locale: {
                                    format: 'MM/DD/YYYY'
                                }
                            }}
                            onApply={this.handleCalendar}>
                            <div className="react-bootstrap-daterangepicker-container">
                                <div className="react-datepicker_input-container first-one">
                                    <input type="text" className="form-control first readonly-attr" value={this.state.startDate} />
                                </div>
                                <div className="react-datepicker_input-container second-one">
                                    <input type="text" className="form-control readonly-attr" value={this.state.endDate} />
                                </div>
                            </div>
                        </DateRangePicker>
                        <div className={this.state.userdata.userrole == "Distributor" || (this.state.userdata.userrole == "Wholesaler" && this.state.userdata.overrideCount > 0) ? 'searchSection add-over' : 'searchSection'}>
                            <img className="SearchIcon" src={Search_Icon} alt="" />

                            <form autoComplete="off" onSubmit={e => { e.preventDefault(); }}>
                                <div className="autocomplete">
                                    <input id="myInput" type="text" name="myCountry" placeholder="Search" className="form-control searchFilter" onFocus={this.HandleSearchFocus} onKeyUp={this.HandleSearchKeyUp} />
                                    {
                                        this.state.SearchDispay != null ? this.state.SearchDispay[0] ?
                                            <div id="myInputautocomplete-list" className="autocomplete-items">
                                                {
                                                    this.state.SearchDispay.map((item, index) => {
                                                        let n_name = "";
                                                        n_name = item.cname;
                                                        return (<div className="searchitempopulate" nodename={item.cname} nodevalue={item.cvalue} nodetype={item.ctype} onClick={this.HandleSearchItemClick}>{n_name}
                                                            <span nodename={item.cname} nodevalue={item.cvalue} nodetype={item.ctype} >{item.cvalue}</span>
                                                        </div>
                                                        )
                                                    })}
                                            </div> : null : null
                                    }
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div >
        )
    }
}
export default AnalyticsHeader_API;